import React, { useState } from "react";
import API_URL from "../apiConfig";

export default function AnnualFeeInput({ batchId, token, onSet }) {
  const [fee, setFee] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    setSaving(true);
    setError("");
    try {
      // Validate input
      const feeVal = Number(fee);
      if (isNaN(feeVal) || feeVal < 0) {
        setError("Please enter a valid non-negative fee amount.");
        setSaving(false);
        return;
      }
      const res = await fetch(`${API_URL}/api/batches/${batchId}/annual-fee`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ annual_fee: feeVal }),
      });
      if (!res.ok) {
        const data = await res.json();
        setError(data.error || "Error setting annual fee");
        setSaving(false);
        return;
      }
      onSet(feeVal);
      setFee("");
    } catch (err) {
      setError("Error connecting to server");
      setSaving(false);
    }
    setSaving(false);
  };

  return (
    <div>
      <b>Set Annual Fee:</b>
      <input
        type="number"
        value={fee}
        min={0}
        onChange={e => setFee(e.target.value)}
        style={{ width: 90, marginLeft: 5 }}
        disabled={saving}
        placeholder="Annual Fee"
      />
      <button onClick={handleSave} disabled={saving || !fee}>Save</button>
      {error && <div style={{color:"red"}}>{error}</div>}
    </div>
  );
}